import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { TERMS } from '../../../core/router/routes';

// Aviso bajo el botón de Google: al ingresar, el alumno acepta los términos de uso
const TermsNotice = () => (
  <div className="text-center md:text-left mt-16">
    <Typography variant="caption" color="text.secondary">
      Al ingresar aceptas los{' '}
      <Link to={TERMS} target="_blank" rel="noopener noreferrer" className="underline">
        Términos de uso
      </Link>
    </Typography>
  </div>
);

export default TermsNotice;
